const environmentProperties = {
    userLocale: window.environment?.userLocale || 'en',
    signInProfileUrl: window.environment?.signInProfileUrl,
    houstonServer: window.environment?.houstonServer,
    nexisUrl: window.environment?.nexisUrl,
    nexisUniUrl: window.environment?.nexisUniUrl,
    diligenceUrl: window.environment?.diligenceUrl,
    entityInsightUrl: window.environment?.entityInsightUrl,
    advanceResearchUrl: window.environment?.advanceResearchUrl,
    lexisPlusUrl: window.environment?.lexisPlusUrl,
    lexisPlusUkUrl: window.environment?.lexisPlusUkUrl,
    lexisPlusSouthAfricaUrl: window.environment?.lexisPlusSouthAfricaUrl,
    nexisPlusAiUrl: window.environment?.nexisPlusAiUrl,
    lnacUrl: window.environment?.lnacUrl,
    helpBaseUrl: window.environment?.helpBaseUrl,
    liveChatUrl: window.environment?.liveChatUrl,
    maxAllowedAlertRecipients: window.environment?.maxAllowedAlertRecipients
};

export { environmentProperties };
